import { Component } from '@angular/core';  
// import { AuthService } from '../../../share/services//auth.service';
import { Router } from '@angular/router';   

@Component({
  selector: 'fetrapi-login',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss']
})
export class MaintenanceComponent {
  isLoading: boolean = false;
  fetrapiSession: any;

  constructor(
    // private auth: AuthService,
    private router: Router
  ) { } 

  
}
